module.exports = __webpack_public_path__ + "img/中国移动.a0e4f351.png";